export const SHOP_TYPE = {
  淘宝: 0,
  拼多多: 1,
  京东: 2,
  抖店: 3,
  淘工厂: 4
}

export const SHOP_TYPE_2 = {
  淘宝: 'c',
  天猫: 'b',
  拼多多: 'p',
  京东: 'j',
  抖店: 'd',
  淘工厂: 't'
}

export const PLATFORM_TYPE = {
  淘宝: 0,
  京东: 1,
  拼多多: 2,
  抖店: 3,
  淘工厂: 4
}

export const PLATFORM_SHOP_TYPE = {
  淘宝: [0, 1],
  拼多多: [2],
  京东: [3],
  抖店: [4],
  淘工厂: [5]
}

export const USER_TYPE = {
  淘宝: 0,
  天猫: 1,
  京东: 3
}

export const PLATFORM_TYPE_DETAIL = {
  [PLATFORM_TYPE['淘宝']]: {
    collectively: '淘宝', // 统称
    platform: '淘宝/天猫',
    officialWebsite: '淘宝网',
    themeColor: '#ff9900',
    iconImg: require('@/assets/icon/icon7.png'),
    iconfont: 'icon-taobao2',
    cashGiftGoodsDetailVoucherCollectionProcess: `点击立即领券<br>复制淘口令`,
    unsearchImgs: ['/upaiyun/Sys/20211026/5633495866340358544.png'] // 领券图解
  },
  [PLATFORM_TYPE['京东']]: {
    collectively: '京东', // 统称
    platform: '京东',
    officialWebsite: '京东',
    themeColor: '#e31912',
    iconImg: require('@/assets/icon/icon3.png'),
    iconfont: 'icon-jingdong',
    cashGiftGoodsDetailVoucherCollectionProcess: `点击立即领券<br>跳转到京东领券`,
    unsearchImgs: ['/upaiyun/Sys/Other/5282267432580161010.jpg'] // 领券图解
  },
  [PLATFORM_TYPE['拼多多']]: {
    collectively: '拼多多', // 统称
    platform: '拼多多',
    officialWebsite: '拼多多',
    themeColor: '#e02e24',
    iconImg: require('@/assets/icon/icon6.png'),
    iconfont: 'icon-pinduoduo1',
    cashGiftGoodsDetailVoucherCollectionProcess: `点击立即领券`,
    unsearchImgs: ['/upaiyun/Sys/20211026/5633495866340358544.png'] // 领券图解
  },
  [PLATFORM_TYPE['抖店']]: {
    collectively: '抖音', // 统称
    platform: '抖音',
    officialWebsite: '抖音',
    themeColor: '#000000',
    iconImg: require('@/assets/icon/icon5.png'),
    iconfont: 'icon-douyin2',
    cashGiftGoodsDetailVoucherCollectionProcess: `点击立即领券`, // 补贴专区领券流程
    unsearchImgs: ['/upaiyun/Sys/20211026/5633495866340358544.png'] // 领券图解
  },
  [PLATFORM_TYPE['淘工厂']]: {
    collectively: '淘宝', // 统称
    platform: '淘宝/天猫',
    officialWebsite: '淘宝网',
    themeColor: '#ff9900',
    iconImg: require('@/assets/icon/icon7.png'),
    iconfont: 'icon-taobao2',
    cashGiftGoodsDetailVoucherCollectionProcess: `点击立即领券<br>复制淘口令`,
    unsearchImgs: ['/upaiyun/Sys/20211026/5633495866340358544.png'] // 领券图解
  }
}

export const DTK_ENTRANCE_TYPE = {
  榜单: 0,
  banner: 1,
  弹窗: 2
}

export const TLJ_ORDER_TYPE = {
  内容版块订单: 0,
  补贴专区订单: 1,
  banner订单: 2,
  弹窗订单: 3
}

export const GAP_DAY_TYPE = {
  当天: 0,
  明天: 1
}

export const LIMIT_TYPE = {
  全量订单: 0,
  免单订单: 1
}

export const LOGOUT_APPLY_FOR_STATUS = {
  待审核: 0,
  审核通过: 1,
  已取消: 2
}

export const SEARCH_TYPE = {
  App自然搜索: 0,
  PC自然搜索: 1,
  APP直通车: 2,
  PC直通车: 3,
  分享口令: 4,
  视频口令: 5,
  直播口令: 6,
  二维码: 7,
  口令: 8
}
